__turbopack_context__.v({
  "controls": "load-more-wrapper-module-scss-module__-bVxKG__controls",
  "helperText": "load-more-wrapper-module-scss-module__-bVxKG__helperText",
});
